import { FlowStepEditor } from "../FlowStepEditor";
import React from "react";
import { TextMergeStep } from "../../../rule-engine-core/Flow/Steps/Rules/TextMergeStep";
// import { StyledButton } from "../../../CommonUI/Components/Button";
// import { ObserveState } from "../../../CommonUI/StateManagement/ObserveState";
// import { BaseFlowRuleStep } from "../../../Common/Flow/Steps/Rules/BaseFlowRuleStep";
// import { PropertyEditorText } from "../../../CommonUI/PropertyEditing/PropertyEditorText";
// import { StateManager } from "../../../Common/Common/StateManager";
// import { Layer } from "../../../CommonUI/Components/Layer";
// import { TextMergeBuilder } from "../../../CommonUI/TextMerge/TextMergeBuilder";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StepEditUI = ({ step }: { step: TextMergeStep }) => {
    // const [open, setOpen] = React.useState<boolean>(false);

    return (
        <></>

        // <>
        //         <StyledButton sx={{color:UIStyleConstants.BLUE_COLOR}} variant="contained" onClick={() => setOpen(true)}>
        //             Edit {step.name || "Rule Step"}
        //         </StyledButton>
        //         {step.needSetOutcomeName && (
        //             <ObserveState
        //                 listenTo={step}
        //                 properties={[BaseFlowRuleStep.OUTCOME_NAME]}
        //                 control={() => (
        //                     <PropertyEditorText
        //                         label="Outcome Name"
        //                         editObject={step}
        //                         propertyName={BaseFlowRuleStep.OUTCOME_NAME}
        //                         updateCallback={() => {
        //                             StateManager.propertyChanged(step, BaseFlowRuleStep.OUTCOME_NAME);
        //                         }}
        //                     />
        //                 )}
        //             />
        //         )}
        //
        //         <UILayer
        //             open={open}
        //             maxWidth={false}
        //             fullScreen
        //             padding="0px 0px"
        //             renderUI={() => (
        //                 <TextMergeBuilder
        //                     definition={step.executable}
        //                     title={step.executable.title || step.name}
        //                     onSave={() => {
        //                         setOpen(false);
        //                     }}
        //                     onCancel={() => {
        //                         StateManager.changed(step);
        //                         setOpen(false);
        //                     }}
        //                 />
        //             )}
        //             onClose={() => setOpen(false)}
        //         />
        //     </>
    );
};

export class TextMergeStepEditor extends FlowStepEditor<TextMergeStep> {
    renderEditUI(): JSX.Element | null {
        return <StepEditUI step={this.stepData} />;
    }
}
